import React, { useEffect, useState } from 'react'
import styles from './style.module.css';

// import { AiOutlineClose } from 'react-icons/ai';
import { VscDebugStart } from 'react-icons/vsc'
import { PiStopBold } from 'react-icons/pi'
import { CiPause1 } from 'react-icons/ci'
import { MdAccessTime } from "react-icons/md";
import { BsLightningChargeFill } from "react-icons/bs";
import { BreathAPIs } from '../../../APIs/BreathAPIs';





function UpcomingBooking(props) {

  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedCharger, setSelectedCharger] = useState(null);

  const {timeFormatAmPm} = props;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(intervalId);
  }, []);


  const [bookings, setBookings] = useState([]);

  const fetchBookings = async () => {
    try {
      const res = await BreathAPIs.getUpcomingBookings();
      setBookings(res.data);
    } catch (error) {
      console.error('Error fetching booking history:', error.message);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const now = currentTime;
  const todaysBookings = bookings?.reduce(
    (acc, booking) => {
      const startTime = new Date(booking.startTime);
      const endTime = new Date(booking.endTime);
      if (endTime < now) {
        acc.past.push(booking);
      } else if (startTime <= now && endTime >= now) {
        acc.current.push(booking);
      } else {
        acc.future.push(booking);
      }
      return acc;
    },
    { past: [], future: [], current: [] }
  );

  useEffect(() => {
    if (todaysBookings?.current.length > 0 && selectedCharger == null) {
      setSelectedCharger(todaysBookings?.current[0]);
    }
  }, [todaysBookings?.current]);

  const getTime = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const formattedStartTime = start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
    const formattedEndTime = end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
    
    return `${formattedStartTime} - ${formattedEndTime}`;
  };



  return (
    <>
      {todaysBookings?.current.length > 0 && <div className={styles['in-progress']}>

        <div className={styles['in-progress-block']}>
          <div className={styles['in-progress-charger']}>
            <span className={styles['charger-name']}>
              <BsLightningChargeFill />
              <select
                className={'form-select'}
                value={selectedCharger ? selectedCharger.chargerTag : undefined}
                onChange={(e) => {
                  setSelectedCharger(todaysBookings?.current[e.target.value]);
                }}
              >
                {todaysBookings?.current.map((element, index) => (
                  <option key={index} value={index}>
                    {element.charger.chargerTag}
                  </option>
                ))}
              </select>
            </span>
            <span className={styles['time-block']}><MdAccessTime />{getTime(selectedCharger?.startTime, selectedCharger?.endTime)}</span>
          </div>

          <div className='d-flex'>

            <button disabled={true} className={`btn btn-danger ${styles['progress-btn']}`}  >
              {/* ⏹️ */}
              {<PiStopBold />}
            </button>

            <button disabled={true} className={`btn btn-warning ${styles['progress-btn']}`}>
              {/* ⏹️ */}
              {<CiPause1 />}
            </button>

            <button className={`btn btn-success ${styles['progress-btn']}`}>
              {/* ▶️ */}
              {<VscDebugStart />}
            </button>

          </div>
        </div>

      </div>}
    </>

  )
}

export default UpcomingBooking